import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'react-toastify';

interface InactiveCompanyActionRestrictionProps {
  children: React.ReactNode;
  actionName?: string;
  showToast?: boolean;
}

const InactiveCompanyActionRestriction: React.FC<InactiveCompanyActionRestrictionProps> = ({ 
  children, 
  actionName = 'This action',
  showToast = true
}) => {
  const { auth } = useAuth();

  // Check if user's company is inactive
  const isCompanyInactive = auth.user?.company_is_active === false;

  const handleClick = (e: React.MouseEvent) => {
    if (isCompanyInactive) {
      e.preventDefault();
      e.stopPropagation();
      if (showToast) {
        toast.error(`${actionName} is not available for inactive companies. Please contact your administrator.`);
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    if (isCompanyInactive) {
      e.preventDefault();
      if (showToast) {
        toast.error(`${actionName} is not available for inactive companies. Please contact your administrator.`);
      }
    }
  };

  if (isCompanyInactive) {
    return (
      <div 
        onClick={handleClick}
        onSubmit={handleSubmit}
        style={{ 
          opacity: 0.6, 
          cursor: 'not-allowed',
          pointerEvents: 'none'
        }}
      >
        {children}
      </div>
    );
  }

  return <>{children}</>;
};

export default InactiveCompanyActionRestriction; 